import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { TextMultipleLangItem } from '@adornis/buchungsheld-db/entities/TextMultipleLangItem.js';
import { emailValidation } from '@adornis/users/db/validators.js';
import { validate } from '@adornis/validation/decorators.js';

/**
 * @entity MatchingWeekSettings
 */
@Entity()
export class MatchingWeekSettings extends MongoEntity {
  static override _class = 'MatchingWeekSettings';
  static override _collectionName = 'matching-week-settings';

  @Field(type => [TextMultipleLangItem])
  imprint: Maybe<TextMultipleLangItem[]>;

  @Field(type => [TextMultipleLangItem])
  privacyPolicy: Maybe<TextMultipleLangItem[]>;

  /**
   * Long-form "Nutzungsbedingungen für Unternehmen" linked from the company
   * registration checkbox. Edited via the admin "Company Terms" tab.
   */
  @Field(type => [TextMultipleLangItem])
  companyTerms: Maybe<TextMultipleLangItem[]>;

  @validate(emailValidation)
  @Field(type => String)
  adminNotificationEmail: Maybe<string>;

  @Field(type => ID)
  emailBannerFileId: Maybe<string>;

  /**
   * PDF of the "Teilnahmevereinbarung Matching Week", linked from the company
   * registration checkbox. Uploaded via the admin "Company Terms" tab.
   */
  @Field(type => ID)
  participationAgreementFileId: Maybe<string>;

  /**
   * The "Stand" date shown in the registration checkbox text (e.g. "03.07.2026").
   * Auto-filled with the upload date, admin-editable — the PDF carries no inline date.
   */
  @Field(type => String)
  participationAgreementDate: Maybe<string>;

  /**
   * Hex color overriding the daisyUI `--color-primary` and the chemistry theme
   * accent (login screen). Unset = default teal, see theme-colors.ts.
   */
  @Field(type => String)
  primaryColor: Maybe<string>;

  /** Hex color overriding `--color-primary-content` (text on primary). Unset = white. */
  @Field(type => String)
  primaryContentColor: Maybe<string>;

  @Field(() => Boolean)
  applicationPhaseClosed: Maybe<boolean>;

  @Field(() => Boolean)
  companyRegistrationClosed: Maybe<boolean>;
}
